/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrgDetailsQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type OrgDetailsQuery = {
  readonly __typename: "Query";
  readonly publicOrgDetails: {
    readonly __typename: "PublicOrgDetails";
    readonly displayName: string;
    readonly ssoEnabled: boolean;
    readonly ssoEnforced: boolean;
    readonly googleAuth: boolean;
    readonly azureAuth: boolean;
    readonly allowsIframing: boolean;
  } | null;
};

export const OrgDetailsDocument = /*#__PURE__*/ gql`
  query OrgDetails($orgId: OrgId!) {
    publicOrgDetails(orgId: $orgId) {
      displayName
      ssoEnabled
      ssoEnforced
      googleAuth
      azureAuth
      allowsIframing
    }
  }
`;

/**
 * __useOrgDetailsQuery__
 *
 * To run a query within a React component, call `useOrgDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDetailsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useOrgDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrgDetailsQuery,
    OrgDetailsQueryVariables
  > &
    (
      | { variables: OrgDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrgDetailsQuery, OrgDetailsQueryVariables>(
    OrgDetailsDocument,
    options,
  );
}
export function useOrgDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrgDetailsQuery,
    OrgDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrgDetailsQuery, OrgDetailsQueryVariables>(
    OrgDetailsDocument,
    options,
  );
}
export function useOrgDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrgDetailsQuery,
    OrgDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OrgDetailsQuery, OrgDetailsQueryVariables>(
    OrgDetailsDocument,
    options,
  );
}
export type OrgDetailsQueryHookResult = ReturnType<typeof useOrgDetailsQuery>;
export type OrgDetailsLazyQueryHookResult = ReturnType<
  typeof useOrgDetailsLazyQuery
>;
export type OrgDetailsSuspenseQueryHookResult = ReturnType<
  typeof useOrgDetailsSuspenseQuery
>;
export type OrgDetailsQueryResult = Apollo.QueryResult<
  OrgDetailsQuery,
  OrgDetailsQueryVariables
>;
